<template>
    <section class="app-main">

        
        <div class="top-bar">

            <el-input  v-model="title" @change="getData()"  placeholder="查询" prefix-icon="el-icon-search" clearable style="width:240px;"></el-input> 
        </div>
        
    
        <!-- 商品列表 -->
        <el-card >
            <el-table ref="table" :data="tableData"  height="500" >
                <el-table-column label="日期"  min-width="120" align="center">
                    <template slot-scope="scope">
                        <i class="el-icon-time"></i>
                        <span style="margin-left: 10px">{{ scope.row.created_at }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="wallet_type_title" label="提现类型"  align="center" min-width="160"></el-table-column>
                <el-table-column prop="nickname" label="申请人" align="center">
                    <template slot-scope="scope">{{scope.row.first_name+'-'+scope.row.last_name}}</template>
                </el-table-column>
                <el-table-column prop="nickname" label="昵称" align="center"> </el-table-column>
                <el-table-column prop="phone" label="联系方式" align="center">
                    <template slot-scope="scope">{{scope.row.phone == '' ? scope.row.email : scope.row.phone}}</template>
                </el-table-column>
                <el-table-column prop="transit_number" label="银行卡号" min-width="160" align="center" >
                     <template slot-scope="scope">{{scope.row.transit_number+' '+scope.row.institiution_number+' '+scope.row.account_number}}</template>
                </el-table-column>
                <el-table-column prop="amount" label="提现金额"  align="center" > </el-table-column>
                <el-table-column prop="service_charge" label="手续费"  align="center" > </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next" style="padding:15px" :total="total" ></el-pagination>
        </el-card>



    </section>
</template>



<script>
import { withdrawal } from '@/api/platform.js'
export default {

    data() {
        return {
            title: '',
           
            tableData:[],
            status:0,
            total:0,
            page:1,

        }
    },
    methods: {
        getData(){
            let params = {
                page:this.page
            }
            if(this.title != ""){
                params.search = this.title;
            }

            withdrawal(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                }else{
                    this.tableData = [] ;
                }
            })
        },

 
        // 点击页数 加载当前点击页的数据
        reloadData(page){
            this.page = page;
            this.getData();
            
        },


      
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
section {
    /deep/ .el-tag + .el-tag{ 
        margin-left: 20px;
    }
    
}
</style>
